import React from "react";
import "./ShipmentDetailsBody.scss";
import { Tab, Nav } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import { getDetailsIcon } from "../../../utils/images";
import ShipmentDetailsPane from "../ShipmentDetailsPane/ShipmentDetailsPane.jsx"

const ShipmentDetailsBody = ({ shipment }) => {
  const tabs = [
    {
      key: "updates",
      name: "Updates",
    },
    {
      key: "attentions",
      name: "Attentions",
    },
    {
      key: "containers",
      name: "Containers",
    },
    {
      key: "location",
      name: "Track Location",
    },
    {
      key: "documents",
      name: "Documents",
    },
    {
      key: "cost",
      name: "Cost",
    },
    {
      key: "watchers",
      name: "Share Access",
    },
    // {
    //   key: "conversations",
    //   name: "Conversations",
    // },
  ]

  return (
    <div className="ShipmentDetailsBody">
      <Tab.Container defaultActiveKey="updates" unmountOnExit={true}>
        <div className="nav-wrapper">
          <Nav className="app-tabs nav">
            {tabs.map((tab) => {
              return (
                <Nav.Item key={tab.key}>
                  <Nav.Link eventKey={tab.key}>
                    <div className="item">
                      <ReactSVG src={getDetailsIcon(tab.key)} />
                      <div>{tab.name}</div>
                    </div>
                  </Nav.Link>
                </Nav.Item>
              )
            })}
          </Nav>
        </div>
        <Tab.Content>
          {tabs.map((tab) => {
            return (
              <Tab.Pane eventKey={tab.key} key={tab.key}>
                <ShipmentDetailsPane pane={tab.key} shipment={shipment} />
              </Tab.Pane>
            )
          })}
        </Tab.Content>
      </Tab.Container>
    </div>
  )
}

export default ShipmentDetailsBody;
